module.exports = __webpack_public_path__ + "static/fav-96116b75c39c814d4094430a44c4d8b8.jpg";